export default __webpack_public_path__ + "static/media/pexels-artem-beliaikin-929245.aab8a388.jpg";